import { List, Stack, Text } from '@mantine/core';
import { DeleteImpact } from '@/utils/deleteImpacts.ts';

type Props = {
  impacts: DeleteImpact[];
  itemLabel: string;
  note?: string;
};

const MAX_VISIBLE_IMPACTS = 5;

const DeleteImpactWarning = ({ impacts, itemLabel, note }: Props) => {
  if (impacts.length === 0) {
    return (
      <Stack gap="xs">
        <Text inherit>Are you sure you want to delete this {itemLabel}?</Text>
        {note && <Text inherit>{note}</Text>}
      </Stack>
    );
  }

  const visibleImpacts = impacts.slice(0, MAX_VISIBLE_IMPACTS);
  const hiddenImpactCount = impacts.length - visibleImpacts.length;

  return (
    <Stack gap="xs">
      <Text inherit>
        Deleting this {itemLabel} will break references in these steps:
      </Text>
      <List size="sm" spacing={4}>
        {visibleImpacts.map((impact) => (
          <List.Item key={impact.stepId}>
            {impact.stepName}
            {impact.reasons.length > 0 ? ` (${impact.reasons.join(', ')})` : ''}
          </List.Item>
        ))}
        {hiddenImpactCount > 0 && <List.Item>{hiddenImpactCount} more</List.Item>}
      </List>
      <Text inherit>You can still delete it, but those steps will need to be updated.</Text>
      {note && <Text inherit>{note}</Text>}
    </Stack>
  );
};

export default DeleteImpactWarning;
